import { render, staticRenderFns } from "./VariationSelect.vue?vue&type=template&id=bdb513a0&"
import script from "./VariationSelect.vue?vue&type=script&lang=js&"
export * from "./VariationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports